/**
 * Acesso tipado às variáveis de ambiente do Vite.
 *
 * Nada de localhost nem domínio de produção no código: a URL da API vem de
 * `VITE_API_URL`. Quando ela é vazia (padrão em desenvolvimento), as
 * requisições saem na mesma origem e o proxy do Vite as encaminha para a API
 * — assim o cookie de sessão HttpOnly funciona sem depender de SameSite=None.
 */
export const env = {
  /** Base da API. Vazio = mesma origem (proxy do Vite / reverse proxy). */
  apiUrl: (import.meta.env.VITE_API_URL ?? "").replace(/\/+$/, ""),
  isDev: import.meta.env.DEV,
} as const;
